export function getMemberPortalUrl(tradingHouse: string, path?: string): string {
  if (tradingHouse === 'gtf') {
    return `https://members.daytradeu.com${path ? path.replace('/dashboard/', '/trading/') : ''}`
  }
  return `https://myaccount.greenchart.com${path ?? ''}`
}
